import { usePageContent } from "@robe/client/xcore-ui";
import { LocalizableNullableString } from "@robe/core";
import { useState, useEffect } from "react";
import { useLayout } from "xcore";

export const useDomainSwitcher = () => {
  const { resolvedDomains, core, config } = useLayout();
  const { id, type } = usePageContent();
  const [pageContentLocalizedSlugs, setPageContentLocalizedSlugs] = useState<{
    slugs: LocalizableNullableString | null;
    id: number | null;
  }>({ slugs: null, id: null });

  const domainsOrder = ["en", "en-NA", "en-SEA", "de", "fr", "ru"]; // Requested domain order from Robe. Remaining domains will be sorted to the end.

  const sortedDomains = Object.entries(resolvedDomains).sort((a, b) => {
    const indexA = domainsOrder.indexOf(a[1]);
    const indexB = domainsOrder.indexOf(b[1]);

    const posA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
    const posB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;

    return posA - posB;
  });

  // Page content only has slug for current locale, fetch remaining locales slugs
  useEffect(() => {
    const fetchContentLocalizedSlugs = async () => {
      const res = await core.content.slugsByIds([id]);

      if (res && Array.isArray(res) && res.length === 1) {
        setPageContentLocalizedSlugs({ slugs: res[0].localizedSlugs, id: res[0].contentId });
      }
    };

    pageContentLocalizedSlugs.id !== id && fetchContentLocalizedSlugs();
  }, [core.content, id, pageContentLocalizedSlugs]);

  return {
    dropdownLinkProps: sortedDomains
      .filter(([d]) => !config.secondaryDomains?.includes(d))
      .map(([_, l]) => ({
        locale: l,
        label: core.locales[l].domainSwitcherLabel,
      })),
    label: core.currentLocaleConfig.domainSwitcherLabel,
    pageContent: pageContentLocalizedSlugs.slugs
      ? {
        id,
        type,
        slug: pageContentLocalizedSlugs.slugs,
      }
      : null,
  };
};
